import { types, getEnv, flow } from 'mobx-state-tree';

import PaymentModule from '../models/PaymentModule';
import StatefulStore from '../models/StatefulStore';
import { stringify } from 'qs';
import PaymentWidgetQueryResult from '../models/PaymentWidgetQueryResult';
import RequestState, { RequestStateType } from '../types/RequestState';
import PaymentWidget from '../models/PaymentWidget';

const PaymentModuleStore = StatefulStore.named('PaymentModuleStore')
  .props({
    methods: types.optional(types.array(PaymentModule), []),
    widgets: types.optional(types.array(PaymentWidget), []),
    paymentWidgetQueryResults: types.optional(
      types.map(PaymentWidgetQueryResult),
      {}
    ),
    paymentWidgetQueryStates: types.optional(types.map(RequestStateType), {})
  })
  .actions((self) => {
    const loadPaymentModules = flow(function* loadPaymentModules(params) {
      // Skip the API call if we already have the data
      if (self.methods.length || self.widgets.length) {
        return;
      }
      self.setLoading(true);
      try {
        const paymentInfo = yield getEnv(self).apiWrapper.request(
          `payment-info`,
          { params }
        );
        self.methods = paymentInfo.methods;
        self.widgets = paymentInfo.widgets;
      } catch (e) {
        self.setError(e);
        throw e;
      }

      self.setLoading(false);
    });

    const loadProductWidget = flow(function* loadProductWidget(params) {
      const identifier = stringify(params);
      // Skip the API call if we already have the data
      if (self.paymentWidgetQueryStates.get(identifier)) {
        return;
      }
      self.setLoading(true);
      self.paymentWidgetQueryStates.set(identifier, RequestState.LOADING);
      let paymentWidget;

      try {
        paymentWidget = yield getEnv(self).apiWrapper.request(
          `payment-info/product-widgets`,
          { params }
        );

        // Set current query results
        self.paymentWidgetQueryResults.set(identifier, {
          widgets: paymentWidget.map((widget) => widget)
        });
      } catch (e) {
        self.setError(e);
        self.paymentWidgetQueryStates.set(identifier, RequestState.ERROR);
        throw e;
      }

      self.setLoading(false);
      self.paymentWidgetQueryStates.set(identifier, RequestState.LOADED);
    });

    return {
      loadPaymentModules,
      loadProductWidget
    };
  })
  .views((self) => ({
    get isKlarnaEnabled() {
      return self.paymentModules.some((p) => p.class === 'klarna_checkout');
    },
    get getPaymentWidgets() {
      return (
        self.widgets &&
        self.widgets.length &&
        self.widgets.find((widget) => widget.type === 'KLARNA')
      );
    }
  }));

export default PaymentModuleStore;



// WEBPACK FOOTER //
// ./src/store/PaymentModuleStore.js